import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=b8e0d01a&"
import script from "./HistoryTab.vue?vue&type=script&lang=js&"
export * from "./HistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e0d01a')) {
      api.createRecord('b8e0d01a', component.options)
    } else {
      api.reload('b8e0d01a', component.options)
    }
    module.hot.accept("./HistoryTab.vue?vue&type=template&id=b8e0d01a&", function () {
      api.rerender('b8e0d01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/components/client-maintain-tabs/HistoryTab.vue"
export default component.exports